var map = {
	"./L_splashscreen.svg": "d5ab",
	"./bar.svg": "077c",
	"./emotionalTransferability.svg": "ee09",
	"./indicator.svg": "9380",
	"./operationalTransferability.svg": "b716",
	"./questionmark.svg": "a29e",
	"./splashscreen.svg": "5860",
	"./structuralTransferability.svg": "303d",
	"./sustainableProfitability.svg": "f2f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64c4";